import React from 'react'
import ReactDOM from 'react-dom/client'
import ValidationApp from './components/ValidationForm'
import WarrantyApp from './components/WarrantyForm'

if (document.getElementById('trust-validation-react-app') !== null) {
  const v_root = ReactDOM.createRoot(
    document.getElementById('trust-validation-react-app'),
  )
  v_root.render(
    <React.StrictMode>
      <ValidationApp />
    </React.StrictMode>,
  )
}

if (document.getElementById('trust-warranty-react-app') !== null) {
  const w_root = ReactDOM.createRoot(
    document.getElementById('trust-warranty-react-app'),
  )
  w_root.render(
    <React.StrictMode>
      <WarrantyApp />
    </React.StrictMode>,
  )
}
